(function ($) {
  $(function () {
    var $siteHeader = $('.site-header.is-sticky');

    if ($siteHeader.length) {
      $(window).on('scroll', function () {
        $siteHeader.toggleClass('navbar-fixed-top', $(this).scrollTop() > 1);
      });
    }

    $(window).on('scroll', function () {
      $('.scroll-to-top').toggleClass('show', $(this).scrollTop() > 150);
    });

    $('.scroll-to-top').on('click', function (event) {
      event.preventDefault();

      $('html, body').animate({
        scrollTop: 0
      }, 700);
    });

    var menuPanel = document.querySelector('.mobile-menu');
    var menuButton = document.querySelector('.menu-btn-burger');
    var navIcon = document.querySelector('#nav-icon');
    var submenuLinks = menuPanel ? menuPanel.querySelectorAll('.menu-item-has-children > a') : [];

    if (menuPanel && menuButton) {
      var setMenuState = function (isOpen) {
        if (!isOpen) {
          submenuLinks.forEach(function (link) {
            link.setAttribute('aria-expanded', 'false');
            link.parentElement.classList.remove('is-submenu-open');
          });
        }

        menuButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        menuPanel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        menuPanel.classList.toggle('is-open', isOpen);

        if (navIcon) {
          navIcon.classList.toggle('open-custom-menu', isOpen);
        }

        menuPanel.style.maxHeight = isOpen ? menuPanel.scrollHeight + 'px' : '0px';
      };

      var toggleMenu = function (event) {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        event.preventDefault();
        setMenuState(!menuPanel.classList.contains('is-open'));
      };

      menuButton.addEventListener('click', toggleMenu);
      menuButton.addEventListener('keydown', toggleMenu);

      submenuLinks.forEach(function (link) {
        link.setAttribute('aria-expanded', 'false');

        link.addEventListener('click', function (event) {
          var parentItem = link.parentElement;
          var isOpen = parentItem.classList.contains('is-submenu-open');

          event.preventDefault();
          event.stopImmediatePropagation();

          link.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          parentItem.classList.toggle('is-submenu-open', !isOpen);

          if (menuPanel.classList.contains('is-open')) {
            menuPanel.style.maxHeight = menuPanel.scrollHeight + 'px';
          }
        });
      });

      $('#my-menu a').on('click', function () {
        setMenuState(false);
      });

      $(window).on('resize orientationchange', function () {
        if (menuPanel.classList.contains('is-open')) {
          menuPanel.style.maxHeight = menuPanel.scrollHeight + 'px';
        }
      });

      setMenuState(false);
    }
  });
})(jQuery);
